import React from "react";
import classNames from "classnames";
import BaseRow from "../BaseRow";
import { EVENT_CATEGORY_LEAD } from "Constants/metriks/GoogleCategorys";
import { CLICK_REDIRECT_LANDING } from "Constants/metriks/GoogleActions";
import Metrika from "Services/Metrika";
import ConnectButton from "Containers/Buttons/ConnectButton";

export default class ButtonsRow extends BaseRow {
	onClickHref = (item) => {
		window.open(item.provider.contacts.link, "_blank");
		Metrika.getInstance().google.sendEvent(EVENT_CATEGORY_LEAD, CLICK_REDIRECT_LANDING);
	};

	generateButtonsOfTarifs() {
		let classes = this.props.classes;
		return this.props.data.map((item, index) => {
			let buttonConnect = (
				<ConnectButton
					data={item}
					provider={item.provider}
					compare={true}
					comparisonConnect={this.props.comparisonConnect}
					onClickHref={() => this.onClickHref(item)}
				/>
			);

			return (
				<div key={index} className={classes.cell}>
					<div className={classes.cellButtonsContainer}>
						<div
							className={classNames(classes.cellButton, classes.cellButtonDelete)}
							onClick={() => {
								this.props.removeCallback(index);
							}}
						>
							<span>{this.props.comparisonDelete}</span>
							<span className="icon24 icon-close" />
						</div>
						<div className={classes.cellButton} datatest="compare_button_connect">
							{buttonConnect}
						</div>
					</div>
				</div>
			);
		});
	}

	render() {
		let classes = this.props.classes;
		let columns = {
			2: [classes.rowColNumber2],
			3: [classes.rowColNumber3],
			4: [classes.rowColNumber4],
			5: [classes.rowColNumber5],
			6: [classes.rowColNumber6],
		};
		let style = {
			transform: `translateX(${this.props.moveValue}px)`,
		};

		return (
			<div className={classNames(classes.row, columns[this.props.columns])}>
				<div className={classes.headerCell} style={style} />
				<div className={classes.cellsWrapper}>{this.generateButtonsOfTarifs()}</div>
			</div>
		);
	}
}
